<template>
	<div id="schools-info">
		<div id="schools-info-popup">
			<div class="result">
				<span class="name flex">
					{{ school.title }}
					<button class="ml-auto" @click="closePopup">X</button>
				</span>
				<span class="street">{{ school.address }}</span>
				<a :href="'tel:+34 '+school.phone" class="phone">
					<img src="/img/icons/phone-icon.svg"/>
					{{ school.phone }}
				</a>
				<span class="whatsapp">
					<img src="/img/icons/whatsapp-icon.svg"/>
					{{ school.phone }}
				</span>

				<div v-if="school.timetable">
					<div class="flex flex-col timetable my-0.5 text-xs" v-html="school.timetable"></div>
				</div>

				<a :href="trans.school + '/' + school.slug" class="discover hover:underline">
					{{ trans.discover }}
					<img src="/img/icons/icons-arrow-right-dark.svg" alt="" />
				</a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			trans: ""
		};
	},
	props: {
		school: {
			type: Object,
			default: () => {
				return [];
			}
		},
		horario: {
			type: Object
		}
	},
	methods: {
		closePopup() {
			return (this.$parent.showPopup = false);
		}
	},
	mounted() {
		this.trans = window?.trans;
	}
};
</script>
